import { create } from 'zustand';

export interface DateRange {
  start: string;
  end: string;
}

interface ReportState {
  dateRange: DateRange;
  selectedCategoryIds: string[];
}

interface ReportActions {
  setDateRange: (range: DateRange) => void;
  setCategoryIds: (categoryIds: string[]) => void;
  clearCategorySelection: () => void;
  resetFilters: () => void;
}

export type ReportStore = ReportState & ReportActions;

function getDefaultDateRange(): DateRange {
  const now = new Date();
  const end = now.toISOString().slice(0, 10);
  const start = new Date(now.getFullYear(), now.getMonth() - 2, 1)
    .toISOString()
    .slice(0, 10);
  return { start, end };
}

const initialState: ReportState = {
  dateRange: getDefaultDateRange(),
  selectedCategoryIds: [],
};

export const useReportStore = create<ReportStore>()((set) => ({
  ...initialState,

  setDateRange: (range) => set({ dateRange: range }),

  setCategoryIds: (categoryIds) => set({ selectedCategoryIds: categoryIds }),

  clearCategorySelection: () => set({ selectedCategoryIds: [] }),

  resetFilters: () =>
    set({
      dateRange: getDefaultDateRange(),
      selectedCategoryIds: [],
    }),
}));
